"use client";
import React, { useEffect, useRef, useState } from "react";
import { navLinksList } from "./NavLinks";
import Link from "next/link";
import allProducts from "@/assets/images/icons/navbar/all-products.svg";
import aiTools from "@/assets/images/icons/navbar/ai-tools.svg";
import integrations from "@/assets/images/icons/navbar/integration.svg";
import Image, { StaticImageData } from "next/image";
import IntegrationContent from "./IntegrationContent";
import { integrationsData } from "@/components/home/Integration/tabs-integration/IntegrationsData";
import AuthButton from "./AuthButton";
import teamIcon from "@/assets/images/icons/navbar/team.svg";
import resourcesIcon from "@/assets/images/icons/navbar/resources.svg";
import industryIcon from "@/assets/images/icons/navbar/industry.svg";
import makeImage from "@/assets/images/icons/navbar/make.svg";
import zapierImage from "@/assets/images/icons/navbar/zapier.svg";
import AiToolsCard from "./AiToolsCard";
import ButtonsSection from "./ButtonsSection";
import krooloAi from "@/assets/images/icons/navbar/kroolo.svg";
import compareIcon from "@/assets/images/icons/navbar/compare.svg";
import krooloAiIcon from "@/assets/images/icons/navbar/ai-tab-icon.svg";

type PropTypes = {
  setExpandableArea: React.Dispatch<React.SetStateAction<number | undefined>>;
  hoveredArea: string;
  setHoveredArea: React.Dispatch<React.SetStateAction<string>>;
  forceRenderValue: number;
};

interface Tab {
  id: number;
  tab: string;
  label: string;
  icon?: StaticImageData;
  image?: StaticImageData | string;
}

interface ProductsTabComponentProps {
  activeProductsTab: string;
  setActiveProductsTab: (tab: string) => void;
}
const ProductsTabComponent = ({
  activeProductsTab,
  setActiveProductsTab,
}: ProductsTabComponentProps) => {
  const tabsData: Tab[] = [
    { id: 1, tab: "kroolo", label: "Kroolo", icon: krooloAi },
    { id: 2, tab: "allProducts", label: "All Features", icon: allProducts },
    { id: 3, tab: "integrations", label: "Integrations", icon: integrations },
    { id: 4, tab: "compare", label: "Compare", icon: compareIcon },
  ];
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  const handleProductsTabChange = (value: string) => {
    setActiveProductsTab(value);
  };
  return (
    <ul className="space-y-2 text-sm font-medium text-gray-500">
      {tabsData.map((tabItem) => (
        <li key={tabItem.id} className="rounded">
          <button
            onClick={() => handleProductsTabChange(tabItem.tab)}
            onMouseEnter={() => setHoveredTab(tabItem.tab)}
            onMouseLeave={() => setHoveredTab(null)}
            className={`group flex w-full items-center justify-between rounded-lg px-[10px] py-[8px] text-left text-base font-medium ${activeProductsTab === tabItem.tab
              ? "bg-[#F0F4FF] text-[--title-color]"
              : "text-gray-500"
              }`}
          >
            <div className="flex items-center gap-2">
              <Image
                src={tabItem.icon || ""}
                alt={tabItem.label}
                width={16}
                height={20}
                className={`h-[1.5rem] w-[1.5rem] filter ${activeProductsTab === tabItem.tab
                  ? "brightness-0"
                  : hoveredTab === tabItem.tab
                    ? "brightness-50"
                    : "brightness-100"
                  }`}
              />
              <span
                className={`text-[14px] font-medium ${activeProductsTab === tabItem.tab
                  ? "text-[#202020]"
                  : hoveredTab === tabItem.tab
                    ? "text-[#202020]"
                    : "text-[#8c8c8c]"
                  }`}
              >
                {tabItem.label}
              </span>
            </div>
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.5L6 7L1 12.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                className="group-hover:stroke-[#202020]"
              />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  );
};
interface KrooloAiTabComponentProps {
  activeKrooloAiTab: string;
    setActiveKrooloAiTab: (tab: string) => void;
}
const KrooloAiTabComponent = ({
  activeKrooloAiTab,
  setActiveKrooloAiTab,
}: KrooloAiTabComponentProps) => {
  const tabsData: Tab[] = [
    { id: 1, tab: "ai", label: "AI", icon: krooloAiIcon },
    { id: 2, tab: "aiTools", label: "AI Tools", icon: aiTools },
  ];
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  const handleKrooloAiTabChange = (value: string) => {
    setActiveKrooloAiTab(value);
  };
  return (
    <ul className="space-y-2 text-sm font-medium text-gray-500 lg:space-y-4">
      {tabsData.map((tabItem) => (
        <li key={tabItem.id} className="rounded">
          <button
            onClick={() => handleKrooloAiTabChange(tabItem.tab)}
            onMouseEnter={() => setHoveredTab(tabItem.tab)}
            onMouseLeave={() => setHoveredTab(null)}
            className={`group flex w-full items-center justify-between rounded-lg px-[10px] py-[8px] text-left text-base font-medium ${activeKrooloAiTab === tabItem.tab
              ? "bg-[#F0F4FF] text-[--title-color]"
              : "text-gray-500"
              }`}
          >
            <div className="flex items-center gap-2">
              <Image
                src={tabItem.icon || ""}
                alt={tabItem.label}
                width={16}
                height={20}
                className={`h-[1.5rem] w-[1.5rem] filter ${activeKrooloAiTab === tabItem.tab
                  ? "brightness-0"
                  : hoveredTab === tabItem.tab
                    ? "brightness-50"
                    : "brightness-100"
                  }`}
              />
              <span
                className={`text-[14px] font-medium ${activeKrooloAiTab === tabItem.tab
                  ? "text-[#202020]"
                  : hoveredTab === tabItem.tab
                    ? "text-[#202020]"
                    : "text-[#8c8c8c]"
                  }`}
              >
                {tabItem.label}
              </span>
            </div>
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.5L6 7L1 12.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                className="group-hover:stroke-[#202020]"
              />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  );
};
interface SolutionTabComponentProps {
  activeSolutionTab: string;
  setActiveSolutionTab: (tab: string) => void;
}
const SolutionTabComponent = ({
  activeSolutionTab,
  setActiveSolutionTab,
}: SolutionTabComponentProps) => {
  const tabsData: Tab[] = [
    { id: 1, tab: "selectSolution", label: "Use Cases", icon: teamIcon },
    { id: 2, tab: "industries", label: "Industries", icon: industryIcon },
  ];
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  const handleSolutionTabChange = (value: string) => {
    setActiveSolutionTab(value);
  };
  return (
    <ul className="space-y-2 text-sm font-medium text-gray-500 lg:space-y-4">
      {tabsData.map((tabItem) => (
        <li key={tabItem.id} className="rounded">
          <button
            onClick={() => handleSolutionTabChange(tabItem.tab)}
            onMouseEnter={() => setHoveredTab(tabItem.tab)}
            onMouseLeave={() => setHoveredTab(null)}
            className={`group flex w-full items-center justify-between rounded-lg px-[10px] py-[8px] text-left text-base font-medium ${activeSolutionTab === tabItem.tab
              ? "bg-[#F0F4FF] text-[--title-color]"
              : "text-gray-500"
              }`}
          >
            <div className="flex items-center gap-2">
              <Image
                src={tabItem.icon || ""}
                alt={tabItem.label}
                width={16}
                height={20}
                className={`h-[1.5rem] w-[1.5rem] filter ${activeSolutionTab === tabItem.tab
                  ? "brightness-0"
                  : hoveredTab === tabItem.tab
                    ? "brightness-50"
                    : "brightness-100"
                  }`}
              />
              <span
                className={`text-[14px] font-medium ${activeSolutionTab === tabItem.tab
                  ? "text-[#202020]"
                  : hoveredTab === tabItem.tab
                    ? "text-[#202020]"
                    : "text-[#8c8c8c]"
                  }`}
              >
                {tabItem.label}
              </span>
            </div>
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.5L6 7L1 12.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                className="group-hover:stroke-[#202020]"
              />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  );
};
interface ResourceTabComponentProps {
  activeResourceTab: string;
  setActiveResourceTab: (tab: string) => void;
}
const ResourceTabComponent = ({
  activeResourceTab,
  setActiveResourceTab,
}: ResourceTabComponentProps) => {
  const tabsData: Tab[] = [
    { id: 1, tab: "selectResource", label: "Resources", icon: resourcesIcon },
  ];
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  const handleResourceTabChange = (value: string) => {
    setActiveResourceTab(value);
  };
  return (
    <ul className="space-y-2 text-sm font-medium text-gray-500 lg:space-y-4">
      {tabsData.map((tabItem) => (
        <li key={tabItem.id} className="rounded">
          <button
            onClick={() => handleResourceTabChange(tabItem.tab)}
            onMouseEnter={() => setHoveredTab(tabItem.tab)}
            onMouseLeave={() => setHoveredTab(null)}
            className={`group flex w-full items-center justify-between rounded-lg px-[10px] py-[8px] text-left text-base font-medium ${activeResourceTab === tabItem.tab
              ? "bg-[#F0F4FF] text-[--title-color]"
              : "text-gray-500"
              }`}
          >
            <div className="flex items-center gap-2">
              <Image
                src={tabItem.icon || ""}
                alt={tabItem.label}
                width={16}
                height={20}
                className={`h-[1.5rem] w-[1.5rem] filter ${activeResourceTab === tabItem.tab
                  ? "brightness-0"
                  : hoveredTab === tabItem.tab
                    ? "brightness-50"
                    : "brightness-100"
                  }`}
              />
              <span
                className={`text-[14px] font-medium ${activeResourceTab === tabItem.tab
                  ? "text-[#202020]"
                  : hoveredTab === tabItem.tab
                    ? "text-[#202020]"
                    : "text-[#8c8c8c]"
                  }`}
              >
                {tabItem.label}
              </span>
            </div>
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.5L6 7L1 12.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                className="group-hover:stroke-[#202020]"
              />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  );
};

const automationsTools = [
  {
    id: 1,
    icon: zapierImage,
    label: "Zapier",
  },
  {
    id: 2,  
    icon: makeImage,
    label: "Make",
  },
];

const NavBottom = ({
  hoveredArea,
  setExpandableArea,
  setHoveredArea,
  forceRenderValue,
}: PropTypes) => {
  const [activeProductsTab, setActiveProductsTab] = useState("kroolo");
  const [activeKrooloAiTab, setActiveKrooloAiTab] = useState("ai");
  const [activeSolutionTab, setActiveSolutionTab] = useState("selectSolution");
  const [activeResourceTab, setActiveResourceTab] = useState("selectResource");
  const productRef = useRef<HTMLDivElement>(null);
  const resourceRef = useRef<HTMLDivElement>(null);
  const solutionRef = useRef<HTMLDivElement>(null);
  const toolsRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (hoveredArea === "products") {
      setExpandableArea(productRef.current?.clientHeight);
    } else if (hoveredArea === "solutions") {
      setExpandableArea(solutionRef.current?.clientHeight);
    } else if (hoveredArea === "kroolo ai") {
      setExpandableArea(toolsRef.current?.clientHeight);
    } else if (hoveredArea === "resources") {
      setExpandableArea(resourceRef.current?.clientHeight);
    }
  }, [
    hoveredArea,
    setExpandableArea,
    forceRenderValue,
    activeProductsTab,
    activeSolutionTab,
    activeKrooloAiTab,
    activeResourceTab,
  ]);

  const handleMouseOver = (areaName: string) => {
    if (areaName === "products") {
      setExpandableArea(productRef.current?.clientHeight);
      setHoveredArea("products");
      if (hoveredArea !== "products") {
        setActiveProductsTab("kroolo");
      }
    } else if (areaName === "solutions") {
      setExpandableArea(solutionRef.current?.clientHeight);
      setHoveredArea("solutions");
      if (hoveredArea !== "solutions") {
        setActiveSolutionTab("selectSolution");
      }
    } else if (areaName === "kroolo ai") {
      setExpandableArea(toolsRef.current?.clientHeight);
      setHoveredArea("kroolo ai");
      if (hoveredArea !== "kroolo ai") {
        setActiveKrooloAiTab("ai");
      }
    } else if (areaName === "resources") {
      setExpandableArea(resourceRef.current?.clientHeight);
      setHoveredArea("resources");
      if (hoveredArea !== "resources") {
        setActiveProductsTab("selectResource");
      }
    }
  };

  // handling mouse leave
  const handleMouseLeave = () => {
    setExpandableArea(undefined);

    setTimeout(() => {
      if (!hoveredArea) {
        setHoveredArea("");
      }
    }, 400);
  };
  const productsLinkObject = navLinksList.find(
    (linkObject) => linkObject.title.toLowerCase() === "products",
  );

  // common div styles with links
  const divSolutionsLinkStyles = `px-4 py-2.5 space-y-1 rounded-lg overflow-hidden block h-fit hover:bg-white`;
  const divProductsLinkStyles = `px-4 py-2.5 space-y-1 rounded-[8px] overflow-hidden block hover:bg-white`;
  const divLinkLabel = `text-[14px] text-[#202020] font-medium shrink-0`;
  const divLinkSubtext = `text-[11px] text-[#8C8C8C] font-normal`;

  // products block
  if (hoveredArea === "products") {
    const selectedArray = navLinksList.find(
      (linkObject) => linkObject.title.toLowerCase() === "products",
    );
    const tabContentMap: Record<
      string,
      | {
        url: string;
        icon?: StaticImageData;
        label: string;
        subtext?: string;
        image?: StaticImageData | string;
      }[]
      | undefined
    > = {
      kroolo: selectedArray?.krooloLinks,
      allProducts: selectedArray?.allProductLinks,
      integrations: selectedArray?.integrationLinks,
      compare: selectedArray?.compareLinks,
    };

    const currentTabContent = tabContentMap[activeProductsTab];
    return (
      <div
        onMouseOver={() => handleMouseOver("products")}
        onMouseLeave={handleMouseLeave}
        ref={productRef}
      >
        <div
          className={`grid grid-cols-6 gap-[2rem] border-b border-[#EAECF0] pb-3 pt-6`}
        >
          <ProductsTabComponent
            activeProductsTab={activeProductsTab}
            setActiveProductsTab={setActiveProductsTab}
          />
          {activeProductsTab === "integrations" ? (
            <div className="col-span-5 grid w-full grid-cols-4 gap-x-4 gap-y-5">
              {Object.entries(integrationsData).map(
                ([key, { label, listData }]) => {
                  if (!listData.length) return null;
                  return (
                    <IntegrationContent
                      tabId={key}
                      label={label}
                      listData={listData}
                      key={key}
                    />
                  );
                },
              )}
              <div className="col-span-4 flex justify-center">
                <AuthButton
                  type="integrationButton"
                  text="View all Integrations"
                  url="/integrations"
                  transparent
                  target="none"
                  textWeightMedium
                  textColor="text-[#484848]"
                />
              </div>
            </div>
          ) : (activeProductsTab === "compare") ? (
            <>
              <div className="col-span-3 grid h-fit grid-cols-2 gap-x-2 gap-y-2">
                {currentTabContent &&
                  currentTabContent.map((singleLink, singleIndex) => {
                    return (
                      <Link
                        onClick={handleMouseLeave}
                        href={singleLink.url}
                        key={singleIndex}
                        className={divProductsLinkStyles}
                      >
                        <div className="flex items-center gap-2 md:gap-[9px]">
                          <Image
                            src={singleLink.icon || ""}
                            alt={singleLink.label || ""}
                            className="h-[1.5rem] w-[1.5rem]"
                          />
                          <p className={divLinkLabel}> {singleLink.label}</p>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            </>
          ) : activeProductsTab === "kroolo" ? (
            <>
              <div className="col-span-3 grid h-fit grid-cols-2 gap-x-6">
                {currentTabContent &&
                  currentTabContent.map((singleLink, singleIndex) => {
                    return (
                      <Link
                        onClick={handleMouseLeave}
                        href={singleLink.url}
                        key={singleIndex}
                        className="hover:shadow-lg hover:shadow-[#d2deff] rounded-lg transition-all duration-300"
                      >
                        <div className="flex items-center justify-center w-full h-[180px] rounded-lg overflow-hidden">
                          <Image
                            src={singleLink.image || ""}
                            alt={singleLink.label || ""}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      </Link>
                    );
                  })}
              </div>
            </>
          ) : (
            <>
              <div className="col-span-3 grid h-fit grid-cols-2 gap-x-2 gap-y-2">
                {currentTabContent &&
                  currentTabContent.map((singleLink, singleIndex) => {
                    return (
                      <Link
                        onClick={handleMouseLeave}
                        href={singleLink.url}
                        key={singleIndex}
                        className={divProductsLinkStyles}
                      >
                        <div className="flex items-center gap-2 md:gap-[9px]">
                          <Image
                            src={singleLink.icon || ""}
                            alt={singleLink.label || ""}
                            className="h-[1.5rem] w-[1.5rem]"
                          />
                          <p className={divLinkLabel}> {singleLink.label} </p>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            </>
          )}
          {(activeProductsTab === "kroolo" ||
            activeProductsTab === "allProducts" ||
            activeProductsTab === "compare") && (
              <AiToolsCard
                aiToolsLinks={productsLinkObject?.aiToolsLinks}
                divLinkLabel={divLinkLabel}
                divLinkSubtext={divLinkSubtext}
                handleMouseLeave={handleMouseLeave}
              />
            )}
          {/* {activeProductsTab === "integrations" && (
            <div className="col-span-1 grid grid-cols-1 gap-x-4 gap-y-4">
              <div className="flex flex-col gap-1 rounded-lg bg-white p-4">
                <h2 className="text-[14px] font-medium text-[#202020]">
                  More Automations
                </h2>
                <div className="space-y-2">
                  {automationsTools.map((tool) => (
                    <div
                      key={tool.label}
                      className="flex cursor-pointer items-center gap-4 rounded-md p-1"
                    >
                      <div className="flex items-center gap-2 md:gap-[9px]">
                        <Image
                          src={tool.icon || ""}
                          alt={tool.label || ""}
                          className="h-[1.5rem] w-[1.5rem]"
                        />
                        <div className="flex flex-col items-start">
                          <p className="text-[14px] font-normal text-[#484848] transition-colors duration-300">
                            {tool.label}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )} */}
        </div>
        {(activeProductsTab === "kroolo" ||
          activeProductsTab === "allProducts" ||
          activeProductsTab === "compare") && <ButtonsSection />}
      </div>
    );
  }

  // solutions block
  else if (hoveredArea === "solutions") {
    const selectedArray = navLinksList.find(
      (linkObject) => linkObject.title.toLowerCase() === "solutions",
    );
    const tabContentMap: Record<
      string,
      | {
        url: string;
        icon?: StaticImageData;
        label: string;
        subtext?: string;
      }[]
      | undefined
    > = {
      selectSolution: selectedArray?.solutionLinks?.filter(
        (link) => link.label,
      ) as {
        url: string;
        icon?: StaticImageData;
        label: string;
        subtext?: string;
      }[],
      industries: selectedArray?.industriesLinks,
    };

    const currentTabContent = tabContentMap[activeSolutionTab];
    return (
      <div
        onMouseOver={() => handleMouseOver("solutions")}
        onMouseLeave={handleMouseLeave}
        ref={solutionRef}
      >
        <div className="grid grid-cols-6 gap-[2rem] border-b border-[#EAECF0] pb-3 pt-6">
          <SolutionTabComponent
            activeSolutionTab={activeSolutionTab}
            setActiveSolutionTab={setActiveSolutionTab}
          />
          <div className="col-span-3 grid h-fit grid-cols-2 gap-x-2 gap-y-2">
            {currentTabContent &&
              currentTabContent.map((singleLink, singleIndex) => {
                return (
                  <Link
                    onClick={handleMouseLeave}
                    href={singleLink.url}
                    key={singleIndex}
                    className={divSolutionsLinkStyles}
                  >
                    <div className="flex items-center gap-2 md:gap-[9px]">
                      <Image
                        src={singleLink.icon || ""}
                        alt={singleLink.label || ""}
                        className="h-[1.5rem] w-[1.5rem]"
                      />
                      <p className={divLinkLabel}> {singleLink.label} </p>
                    </div>
                  </Link>
                );
              })}
          </div>
          <AiToolsCard
            aiToolsLinks={productsLinkObject?.aiToolsLinks}
            divLinkLabel={divLinkLabel}
            divLinkSubtext={divLinkSubtext}
            handleMouseLeave={handleMouseLeave}
          />
        </div>
        <ButtonsSection />
      </div>
    );
  } else if (hoveredArea === "kroolo ai") {
    const selectedArray = navLinksList.find(
      (linkObject) => linkObject.title.toLowerCase() === "kroolo ai",
    );
    const tabContentMap: Record<
      string,
      | {
        url: string;
        icon?: string | StaticImageData;
        label: string;
        subtext?: string;
      }[]
      | undefined
    > = {
      ai: selectedArray?.krooloAiLinks as {
        url: string;
        icon?: string | StaticImageData;
        label: string;
        subtext?: string;
      }[],
      aiTools: selectedArray?.aiToolsLinks as {
        url: string;
        icon?: string | StaticImageData;
        label: string;
        subtext?: string;
      }[],
    };

    const currentTabContent = tabContentMap[activeKrooloAiTab];
    return (
      <div
        onMouseOver={() => handleMouseOver("kroolo ai")}
        onMouseLeave={handleMouseLeave}
        ref={toolsRef}
      >
        <div className="grid grid-cols-6 gap-[2rem] border-b border-[#EAECF0] pb-3 pt-6">
        <KrooloAiTabComponent
          activeKrooloAiTab={activeKrooloAiTab}
          setActiveKrooloAiTab={setActiveKrooloAiTab}
        />
        {activeKrooloAiTab === "ai" ? (
          <>
            <div className="col-span-3 grid h-fit grid-cols-2 gap-x-6">
              {currentTabContent &&
                currentTabContent.map((singleLink, singleIndex) => (
                  <Link
                    onClick={handleMouseLeave}
                    href={singleLink.url}
                    key={singleIndex}
                    className="hover:shadow-lg hover:shadow-[#d2deff] rounded-lg transition-all duration-300"
                  >
                    <div className="flex h-[180px] w-full items-center justify-center overflow-hidden rounded-lg">
                      <Image
                        src={(singleLink as any).image || singleLink.icon || ""}
                        alt={singleLink.label || ""}
                        className="h-full w-full object-cover"
                      />
                    </div>
                  </Link>
                ))}
            </div>
            <AiToolsCard
              aiToolsLinks={selectedArray?.aiToolsLinks as any}
              divLinkLabel={divLinkLabel}
              divLinkSubtext={divLinkSubtext}
              handleMouseLeave={handleMouseLeave}
            />
          </>
        ) : (
          <>
          <div className="col-span-5 grid grid-cols-2 gap-x-2 gap-y-2">
            {currentTabContent &&
              currentTabContent.map((singleLink, singleIndex) => (
                <Link
                  onClick={handleMouseLeave}
                  href={singleLink.url}
                  key={singleIndex}
                  className={divProductsLinkStyles}
                >
                  <div className="flex items-center gap-2 md:gap-[9px]">
                    <Image
                      src={singleLink.icon || ""}
                      alt={singleLink.label || ""}
                      className="h-[1.5rem] w-[1.5rem]"
                    />
                    <p className={divLinkLabel}> {singleLink.label} </p>
                  </div>
                  <p className={divLinkSubtext}> {singleLink.subtext} </p>
                </Link>
              ))}
          </div>
          </>
        )}
        </div>
        <div className="col-span-6">
          <ButtonsSection />
        </div>
      </div>
    );
  } else if (hoveredArea === "resources") {
    const selectedArray = navLinksList.find(
      (linkObject) => linkObject.title.toLowerCase() === "resources",
    );
    const tabContentMap: Record<
      string,
      | {
        url: string;
        icon?: string;
        label: string;
        subtext?: string;
      }[]
      | undefined
    > = {
      selectResource: selectedArray?.innerLinks?.filter(
        (link) => link.label,
      ) as {
        url: string;
        icon?: string;
        label: string;
        subtext?: string;
      }[],
    };

    const currentTabContent = tabContentMap[activeResourceTab];
    return (
      <div
        onMouseOver={() => handleMouseOver("resources")}
        onMouseLeave={handleMouseLeave}
        ref={resourceRef}
        className="grid grid-cols-6 gap-[2rem] pt-6"
      >
        <ResourceTabComponent
          activeResourceTab={activeResourceTab}
          setActiveResourceTab={setActiveResourceTab}
        />
        <div className="col-span-5 grid grid-cols-2 gap-x-2 gap-y-2">
          {currentTabContent &&
            currentTabContent.map((singleLink, singleIndex) => {
              return (
                <Link
                  onClick={handleMouseLeave}
                  href={singleLink.url}
                  key={singleIndex}
                  className={divProductsLinkStyles}
                >
                  <div className="flex items-center gap-2 md:gap-[9px]">
                    <Image
                      src={singleLink.icon || ""}
                      alt={singleLink.label || ""}
                      className="h-[1.5rem] w-[1.5rem]"
                    />
                    <p className={divLinkLabel}> {singleLink.label} </p>
                  </div>
                  <p className={divLinkSubtext}> {singleLink.subtext} </p>
                </Link>
              );
            })}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default NavBottom;
